let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eufZR"), load("6zfzy"), load("bVsPB")]).then(() => parcelRequire('5FaAq'));